var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { useScrollPosition } from '../../hooks/useScrollPosition';
export const Scroll = (_a) => {
    var { el: ScrollElement = 'div', children, className, height: maxHeight, width: maxWidth, horizontal = 'auto', vertical = 'auto', scrollIndicator = false, scrollbar } = _a, props = __rest(_a, ["el", "children", "className", "height", "width", "horizontal", "vertical", "scrollIndicator", "scrollbar"]);
    const scrollbarRef = React.useRef(null);
    const { top, right, bottom, left } = useScrollPosition(scrollbarRef);
    const isScrollable = top ||
        right ||
        bottom ||
        left ||
        horizontal === 'scroll' ||
        vertical === 'scroll';
    const ScrollClasses = classnames('Scroll', className, {
        [`Scroll--of-x-${horizontal}`]: horizontal,
        [`Scroll--of-y-${vertical}`]: vertical,
        'Scroll--scrollable-top': top,
        'Scroll--scrollable-right': right,
        'Scroll--scrollable-bottom': bottom,
        'Scroll--scrollable-left': left,
        'Scroll--hidden-scrollbar': scrollbar === 'hidden',
        'Scroll--height-auto': !maxHeight,
        'Scroll--width-auto': !maxWidth,
    });
    const shadows = (React.createElement("div", { className: "Scroll__Shadows" },
        React.createElement("div", { className: "Shadow--top" }),
        React.createElement("div", { className: "Shadow--right" }),
        React.createElement("div", { className: "Shadow--bottom" }),
        React.createElement("div", { className: "Shadow--left" })));
    const styles = {
        maxWidth,
        maxHeight,
    };
    return (React.createElement(ScrollElement, { className: ScrollClasses, style: styles, "data-anvil-component": "Scroll" },
        scrollIndicator && shadows,
        React.createElement("div", Object.assign({ className: "Scroll__Scrollbar", tabIndex: props.tabIndex || isScrollable ? 0 : null, ref: scrollbarRef }, props), children)));
};
//# sourceMappingURL=Scroll.js.map